function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { modalActions } from '../../reducers/modal.reducer';
import { appActions } from '../../reducers/app.reducer';
import Popup from '../modal/Popup.modal';
var SubHeader = function SubHeader(_ref) {
  var clientEnv = _ref.clientEnv,
    navigation = _ref.navigation,
    showModalAction = _ref.showModalAction,
    modal = _ref.modal,
    gaEventAction = _ref.gaEventAction;
  var navigate = useNavigate();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    navItems = _useState4[0],
    setNavItems = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    tabs = _useState6[0],
    setTabs = _useState6[1];
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  useEffect(function () {
    $('#our-purpose').on('click', function () {
      $.event.trigger('reset');
    });
    var img = new window.Image();
    img.onload = function () {
      img.onload = function () {};
      img.src = '/public/images/Posillico-WashPlant-Nav-RO.png';
    };
    img.src = '/public/images/Posillico-Inc-Nav-RO.png';
  }, []);
  var _getParent = function getParent(item, arr) {
    if (item.parentID) {
      if (!arr) arr = [];
      var tmpItem = navItems.find(function (x) {
        return x._id === item.parentID;
      });
      arr.unshift(tmpItem);
      if (tmpItem.parentID) _getParent(tmpItem, arr);else return arr;
    }
    return arr;
  };
  useEffect(function () {
    var tmpArr = [];
    var tmpItem = navItems.find(function (x) {
      return x.internalUrl === pathname;
    });
    if (tmpItem && pathname !== '/') {
      tmpArr.push(tmpItem);
      var tmpParentArr = _getParent(tmpItem, null);
      if (tmpParentArr) tmpArr = [].concat(_toConsumableArray(tmpParentArr), _toConsumableArray(tmpArr));
    }
    setTabs(tmpArr);
    var activePopup = modal.windows.length > 0 && modal.windows[modal.windows.length - 1];
    var active = false;
    activePopup && navItems.forEach(function (x) {
      var _activePopup$componen, _activePopup$componen2;
      if (x.popup === (activePopup === null || activePopup === void 0 ? void 0 : (_activePopup$componen = activePopup.component) === null || _activePopup$componen === void 0 ? void 0 : (_activePopup$componen2 = _activePopup$componen.props) === null || _activePopup$componen2 === void 0 ? void 0 : _activePopup$componen2.popupID)) active = x;
    });
    if (!activePopup) navItems.forEach(function (x) {
      if (x.internalUrl === pathname) active = x;
    });
    setActive(active || null);
  }, [pathname, modal, navItems]);
  useEffect(function () {
    setNavItems(Object.values(navigation).filter(function (x) {
      return x.navbar === 'header';
    }).filter(function (x) {
      var published = false;
      x.published.forEach(function (y) {
        if ((clientEnv === 'local' || y.clientEnv === clientEnv) && y.published !== false) published = true;
      });
      if (published) return x;
    }).sort(function (a, b) {
      return a.slot - b.slot;
    }));
  }, [navigation]);
  useEffect(function () {
    tabs.forEach(function (x, i) {
      $("#tab".concat(i)).css({
        top: 0
      });
    });
  }, [tabs]);
  return /*#__PURE__*/React.createElement("div", {
    className: "sub-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sub-header__parent"
  }, /*#__PURE__*/React.createElement("ul", null, navItems.filter(function (x) {
    return !x.parentID;
  }).map(function (x) {
    var _tabs$;
    var highlight = false;
    if (x.popup && x.popup === (active === null || active === void 0 ? void 0 : active.popup)) highlight = true;
    if (x._id === ((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$._id)) highlight = true;
    return /*#__PURE__*/React.createElement("li", {
      className: !active || highlight ? '' : 'sub-header__inactive',
      id: x.internalUrl,
      onClick: function onClick() {
        if (clientEnv !== 'prod' && x.title === 'Submit A Project') {
          navigate('/submit-project');
          return;
        }
        if (x.externalUrl) {
          gaEventAction({
            category: 'External URL',
            action: 'click',
            label: x.externalUrl
          });
          window.open(x.externalUrl, '_blank');
        }
        if (x.popup) {
          showModalAction({
            component: /*#__PURE__*/React.createElement(Popup, {
              popupID: x.popup
            })
          });
        }
        if (!x.popup) setTabs([x]);
      },
      key: "sub-header".concat(x.title.replace(' ', ''))
    }, /*#__PURE__*/React.createElement(Url, {
      url: x.internalUrl
    }, x.title));
  })), /*#__PURE__*/React.createElement("div", {
    className: "sub-header__sites"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sub-header__sites--posillico",
    onClick: function onClick() {
      gaEventAction({
        category: 'External URL',
        action: 'click',
        label: 'https://www.posillicoinc.com'
      });
      window.open('https://www.posillicoinc.com', '_blank');
    },
    onMouseEnter: function onMouseEnter() {
      $('.sub-header__sites--posillico').css({
        backgroundImage: 'url(/public/images/Posillico-Inc-Nav-RO.png)'
      });
    },
    onMouseLeave: function onMouseLeave() {
      $('.sub-header__sites--posillico').css({
        backgroundImage: 'url(/public/images/Posillico-Inc-Nav.png)'
      });
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "sub-header__sites--washplant",
    onClick: function onClick() {
      gaEventAction({
        category: 'External URL',
        action: 'click',
        label: 'https://www.posillicowashplant.com'
      });
      window.open('https://www.posillicowashplant.com', '_blank');
    },
    onMouseEnter: function onMouseEnter() {
      $('.sub-header__sites--washplant').css({
        backgroundImage: 'url(/public/images/Posillico-WashPlant-Nav-RO.png)'
      });
    },
    onMouseLeave: function onMouseLeave() {
      $('.sub-header__sites--washplant').css({
        backgroundImage: 'url(/public/images/Posillico-WashPlant-Nav.png)'
      });
    }
  }))), tabs.map(function (x, i) {
    if (!x.children) return null;
    return /*#__PURE__*/React.createElement("div", {
      id: "tab".concat(i),
      className: "sub-header__child",
      style: {
        zIndex: 10 - i
      },
      key: "tabs".concat(x)
    }, /*#__PURE__*/React.createElement("ul", null, navItems.filter(function (y) {
      return y.parentID === x._id;
    }).map(function (y) {
      var _tabs;
      var highlight = false;
      if (y.popup && y.popup === (active === null || active === void 0 ? void 0 : active.popup)) highlight = true;
      if (y._id === ((_tabs = tabs[i + 1]) === null || _tabs === void 0 ? void 0 : _tabs._id)) highlight = true;
      return /*#__PURE__*/React.createElement("li", {
        className: !active || highlight ? '' : 'sub-header__inactive',
        id: y.internalUrl,
        onClick: function onClick() {
          if (y.externalUrl) {
            gaEventAction({
              category: 'External URL',
              action: 'click',
              label: y.externalUrl
            });
            window.open(y.externalUrl, '_blank');
          }
          if (y.popup) {
            showModalAction({
              component: /*#__PURE__*/React.createElement(Popup, {
                popupID: y.popup
              })
            });
          }
          if (!y.popup) setTabs([].concat(_toConsumableArray(tabs.slice(0, i + 1)), [y]));
        },
        key: "sub-header".concat(y.title.replace(' ', ''))
      }, /*#__PURE__*/React.createElement(Url, {
        url: y.internalUrl
      }, y.title));
    })));
  }));
};
var mstp = function mstp(s) {
  return {
    navigation: s.app.navigation,
    clientEnv: s.app.clientEnv,
    modal: s.modal
  };
};
var mdtp = {
  showModalAction: modalActions.show,
  gaEventAction: appActions.gaEvent
};
export default connect(mstp, mdtp)(SubHeader);
var Url = function Url(_ref2) {
  var url = _ref2.url,
    children = _ref2.children;
  if (url) return /*#__PURE__*/React.createElement(NavLink, {
    to: url
  }, children);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};